import { useState, useEffect, useCallback } from 'react';
import { getCursosPublicos, getMatriculasDoUsuario, matricularEmCurso } from '@/services/academyService';

export function useAcademy() {
  const [cursos, setCursos] = useState([]);
  const [matriculas, setMatriculas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchAcademyData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const [cData, mData] = await Promise.all([
        getCursosPublicos(),
        getMatriculasDoUsuario()
      ]);
      setCursos(cData || []);
      setMatriculas(mData || []);
    } catch (err) {
      console.error(err);
      setError(err.message || 'Erro ao carregar dados da academia.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAcademyData();
  }, [fetchAcademyData]);

  const matricular = async (cursoId) => {
    try {
      await matricularEmCurso(cursoId);
      await fetchAcademyData(); // Refresh enrollments
      return true;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  return { 
    cursos, 
    matriculas, 
    loading, 
    error,
    matricular,
    refetch: fetchAcademyData 
  };
}